<template>
  <a-layout class="render-material">
    <a-layout-header class="render-material__header">
      <a-row class="render-material__row">
        <a-col :span="24" class="render-material__col">
          <a-input-search
            size="large"
            placeholder="Material Slug"
            v-model="material"
            @search="filterIdentifiers()"
          >
            <a-button type="primary" slot="enterButton">
              {{ material != "" ? "Carregar" : "Regerar" }}
            </a-button>
          </a-input-search>
        </a-col>
      </a-row>
    </a-layout-header>
    <a-layout-content
      class="render-material__content"
      v-if="customizations.length"
    >
      <a-card
        v-for="customization in customizations"
        :key="customization.identifier"
        :title="customization.identifier"
        class="render-material__card"
      >
        <div class="render-material__preview">
          <preview-component
            v-if="customization && material"
            :canvasComponent="canvasComponent"
            :canvas="{
              customization: customization,
              material: material,
            }"
            :preview-props="{
              deviceProportionInScreen: 0.85,
              customization: customization,
              material: material,
              height: 300,
            }"
          />
        </div>
      </a-card>
    </a-layout-content>
  </a-layout>
</template>

<script>
/* istanbul ignore file */
import PreviewComponent from "@gocasebr/go-shared/dist/preview-component/PreviewComponent";
import CanvasComponent from "@gocasebr/prisma/dist/canvas-component/CanvasComponent";
import {
  getCustomization,
  getCustomizationsIdentifier,
} from "@/api/catalog-api/design-customization-api/designCustomization.api.js";

export default {
  components: { PreviewComponent },
  data() {
    return {
      allIdentifiers: null,
      identifiers: [],
      customizations: [],
      material: null,
    };
  },
  computed: {
    canvasComponent() {
      return CanvasComponent;
    },
  },
  mounted() {
    getCustomizationsIdentifier().then(
      (response) => (this.allIdentifiers = response)
    );
  },
  methods: {
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    filterIdentifiers() {
      var i = 0;
      this.identifiers = [];
      while (i < 30) {
        const identifier = this.allIdentifiers[
          this.getRndInteger(0, this.allIdentifiers.length)
        ].identifier;
        if (!this.identifiers.includes(identifier)) {
          this.identifiers.push(identifier);
          i++;
        }
      }
      this.fetchCustomizations();
    },
    fetchCustomizations() {
      const { material } = this;
      this.customizations = [];
      this.identifiers.forEach((identifier) => {
        getCustomization({
          identifier,
          material,
        }).then((customization) => this.customizations.push(customization));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.render-material {
  background: #fff;
  .render-material__content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
  }

  .render-material__row,
  .render-material__col {
    display: flex;
    align-items: center;
  }

  .render-material__card {
    margin: 6px;
  }

  .render-material__preview {
    width: 300px;
    height: 300px;
    position: relative;
  }
}
</style>
